export default __webpack_public_path__ + "static/media/manage_challenges_template.76e4cc62.svg";